import { ROUTE_PATHS } from '@/config/constants';
import { routes } from '@/config/routes';

type Path = (typeof ROUTE_PATHS)[keyof typeof ROUTE_PATHS];

export function useRouteInfo(path: Path) {
  return routes.find((route) => route.path === path);
}
